module.exports = {"id":"227873","name":"Almamy Touré","rating":"73","photo":"./data/images/photos/4/227873.png","club":{"name":"AS Monaco","logo":"./data/images/clubs/ASMonaco.png"},"positions":["DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlmamyToure0.json
// module id = 301
// module chunks = 0